export type MembershipTier = 'none' | 'single' | 'silver' | 'gold' | 'diamond'

export interface MembershipFeature {
  text: string
  highlight?: boolean
}

export interface MembershipPlan {
  key: MembershipTier
  name: string
  audience: string
  price: number /// 元
  promoPrice?: number | null
  priceUnit: string
  subPrice?: string
  features: MembershipFeature[]
  actionLabel: string
  theme: 'light' | 'silver' | 'gold' | 'dark'
  /** 档位等级，越大越高（1单买…4钻石） */
  rank?: number
}

export interface RefillPack {
  key: string
  price: number /// 元
  points: number
  bonusPoints?: number
}

export interface StorageExpansionPlan {
  key: string
  name: string
  extraGb: number
  billingCycle: 'month' | 'year'
  durationDays: number
  price: number /// 元
  promoPrice?: number | null
  priceUnit: string
  memberOnly?: boolean
  /** 档位等级，越大越高 */
  rank?: number
}

export const MEMBERSHIP_PLANS: MembershipPlan[] = [
  {
    key: 'single',
    name: '单买',
    audience: '适用于个人体验使用',
    price: 9.9,
    priceUnit: '/次',
    features: [
      { text: '每月 0 积分', highlight: true },
      { text: '模型生成权限' },
      { text: '历史记录 1 天' },
      { text: '下载 15 个/月', highlight: true },
      { text: '低模生成' },
      { text: '图像/文本生成 3D' },
    ],
    actionLabel: '立即购买',
    theme: 'light',
  },
  {
    key: 'silver',
    name: '白银会员',
    audience: '适用于个人或小型公司使用',
    price: 100,
    priceUnit: '/月',
    subPrice: '6元/次/60积分',
    features: [
      { text: '1000 积分/月', highlight: true },
      { text: '模型生成权限' },
      { text: '历史记录 7 天' },
      { text: '下载 60 个/月', highlight: true },
      { text: '批量生成 10 个' },
      { text: '高清纹理' },
      { text: '多视图转 3D' },
      { text: '图像/文本生成 3D' },
      { text: '存储 60 个模型', highlight: true },
    ],
    actionLabel: '立即开通',
    theme: 'silver',
  },
  {
    key: 'gold',
    name: '黄金会员',
    audience: '适用于中小型公司使用',
    price: 500,
    priceUnit: '/月',
    subPrice: '5元/次/50积分',
    features: [
      { text: '5000 积分/月', highlight: true },
      { text: '模型生成权限' },
      { text: '历史记录 30 天' },
      { text: '下载 200 个/月', highlight: true },
      { text: '批量生成 20 个' },
      { text: '高清纹理' },
      { text: '多视图转 3D' },
      { text: '图像/文本生成 3D' },
      { text: '存储 200 个模型', highlight: true },
    ],
    actionLabel: '立即开通',
    theme: 'gold',
  },
  {
    key: 'diamond',
    name: '钻石会员',
    audience: '适用于企业大型公司使用',
    price: 4000,
    priceUnit: '/月',
    subPrice: '4元/次/40积分',
    features: [
      { text: '40000 积分/月', highlight: true },
      { text: '模型生成权限' },
      { text: '历史记录永久' },
      { text: '下载不限次数', highlight: true },
      { text: '批量生成 50 个' },
      { text: '高清纹理' },
      { text: '多视图转 3D' },
      { text: '图像/文本生成 3D' },
      { text: '无限存储', highlight: true },
    ],
    actionLabel: '立即开通',
    theme: 'dark',
  },
]

export const REFILL_PACKS: RefillPack[] = [
  { key: 'pack-50', price: 50, points: 500 },
  { key: 'pack-100', price: 100, points: 1000, bonusPoints: 100 },
  { key: 'pack-500', price: 500, points: 5000, bonusPoints: 600 },
  { key: 'pack-1000', price: 1000, points: 10000, bonusPoints: 720 },
]

export const TIER_LABEL: Record<MembershipTier, string> = {
  none: '未开通',
  single: '单买用户',
  silver: '白银会员',
  gold: '黄金会员',
  diamond: '钻石会员',
}

export const POINTS_ROLLOVER_TIP = '未使用的月度积分不会累计到下个月'
